import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowRight,FiUsers,FiTrendingUp,FiTarget,FiAward}=FiIcons;

const Home=()=> {
  const features=[ 
    {icon: FiUsers,title: 'Interactive Q&A Forum',description: 'Ask questions and get answers from peers and Professor Klein',link: '/questions'},
    {icon: FiTrendingUp,title: 'Marketing Resources',description: 'Access comprehensive study materials and case studies',link: '/resources'},
    {icon: FiTarget,title: 'Sports Marketing Focus',description: 'Specialized content for sports marketing strategies',link: '/courses'},
    {icon: FiAward,title: 'Expert Guidance',description: 'Learn from Professor Klein\'s industry experience',link: '/contact'} 
  ];

  return ( 
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12"> 
      {/* Hero Section */} 
      <motion.div initial={{opacity: 0,y: 30}} animate={{opacity: 1,y: 0}} transition={{duration: 0.8}} className="text-center mb-16" > 
        <div className="flex justify-center mb-6"> 
          <img src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1751577427758-blob" alt="Professor Klein" className="w-32 h-32 rounded-full border-4 border-blue-600 shadow-lg object-cover" /> 
        </div> 
        <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-4"> Professor Klein </h1> 
        <h2 className="text-2xl md:text-3xl font-semibold text-blue-600 mb-6"> Class Support Hub </h2> 
        <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto"> Your comprehensive platform for marketing and sports marketing education. Ask questions,access resources,and enhance your learning experience with Professor Klein's guidance. </p> 
        <div className="flex flex-col sm:flex-row gap-4 justify-center"> 
          <Link to="/questions" className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors flex items-center justify-center space-x-2" > 
            <span>Start Learning</span> 
            <SafeIcon icon={FiArrowRight} /> 
          </Link> 
          <Link to="/resources" className="border-2 border-blue-600 text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors" > Browse Resources </Link> 
        </div> 
      </motion.div> 

      {/* Features Grid */} 
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16"> 
        {features.map((feature,index)=> ( 
          <motion.div key={index} initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{duration: 0.6,delay: index * 0.1}} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow" > 
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4"> 
              <SafeIcon icon={feature.icon} className="text-blue-600 text-xl" /> 
            </div> 
            <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3> 
            <p className="text-gray-600 mb-4">{feature.description}</p> 
            <Link to={feature.link} className="text-blue-600 hover:text-blue-700 font-medium flex items-center space-x-1" > 
              <span>Learn More</span> 
              <SafeIcon icon={FiArrowRight} className="text-sm" /> 
            </Link> 
          </motion.div> 
        ))} 
      </div> 

      {/* About Professor Klein */} 
      <motion.div initial={{opacity: 0,y: 30}} animate={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: 0.2}} className="bg-white rounded-2xl shadow-lg p-8 mb-16" > 
        <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Meet Professor Klein</h2>
        <div className="flex flex-col lg:flex-row items-center gap-8"> 
          <div className="flex justify-center">
            <img src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1751577427758-blob" alt="Professor Klein" className="w-48 h-48 rounded-xl shadow-md object-cover" /> 
          </div>
          <div className="flex-1 text-center lg:text-left"> 
            <p className="text-gray-600 text-lg leading-relaxed mb-6"> 
              Professor Klein brings over 30 years of marketing experience to the classroom, specializing in sports marketing and marketing strategy. With a passion for teaching and real-world application, Professor Klein helps students bridge the gap between theory and practice, combining academic rigor with industry insights to create an engaging and practical learning environment.
            </p> 
            <div className="text-center lg:text-left"> 
              <h4 className="font-semibold text-blue-600 mb-3">Areas of Expertise</h4> 
              <div className="flex flex-wrap justify-center lg:justify-start gap-2"> 
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Brand Strategy</span>
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Business Development</span>
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Consumer Behavior</span>
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Marketing Strategy</span>
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Sales</span>
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Sports Marketing</span>
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Sports Sponsorship</span>
              </div> 
            </div> 
          </div> 
          <div className="flex justify-center">
            <img src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1751578494771-blob" alt="Professor Klein Teaching" className="w-48 h-48 rounded-xl shadow-md object-cover" /> 
          </div>
        </div> 
      </motion.div> 

      {/* Course Highlights */} 
      <motion.div initial={{opacity: 0,y: 30}} animate={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: 0.4}} className="bg-white rounded-2xl shadow-lg p-8 mb-16" > 
        <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Course Highlights</h2> 
        <div className="grid md:grid-cols-2 gap-8"> 
          <div className="space-y-4"> 
            <h3 className="text-xl font-semibold text-blue-600">Marketing Fundamentals</h3> 
            <ul className="space-y-2 text-gray-600"> 
              <li>• Consumer Behavior Analysis</li> 
              <li>• Market Research Techniques</li> 
              <li>• Brand Strategy Development</li> 
              <li>• Digital Marketing Strategies</li> 
            </ul> 
          </div> 
          <div className="space-y-4"> 
            <h3 className="text-xl font-semibold text-blue-600">Sports Marketing</h3> 
            <ul className="space-y-2 text-gray-600"> 
              <li>• Sports Sponsorship Strategies</li> 
              <li>• Event Marketing & Management</li> 
              <li>• Athlete Endorsement Deals</li> 
              <li>• Fan Engagement Tactics</li> 
            </ul> 
          </div> 
        </div> 
      </motion.div> 

      {/* Call to Action */} 
      <motion.div initial={{opacity: 0,y: 30}} animate={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: 0.6}} className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl p-8 text-center text-white" > 
        <h2 className="text-3xl font-bold mb-4">Ready to Excel in Marketing?</h2> 
        <p className="text-xl mb-6 opacity-90"> Join Professor Klein's community of learners and take your marketing skills to the next level. </p> 
        <Link to="/questions" className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors inline-flex items-center space-x-2" > 
          <span>Get Started Today</span> 
          <SafeIcon icon={FiArrowRight} /> 
        </Link> 
      </motion.div> 
    </div> 
  );
};

export default Home;